import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './sections/HeroSection';
import { VideoSection } from './sections/VideoSection';
import { StatsSection } from './sections/StatsSection';
import { ProblemSection } from './sections/ProblemSection';
import { ProcessSection } from './sections/ProcessSection';
import { WhoIsThisFor } from './sections/WhoIsThisFor';
import { FoundersSection } from './sections/FoundersSection';
import { FinalCTA } from './sections/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans selection:bg-brand-gold/30 bg-brand-cream" data-id="element-0">
      <div className="h-[2px] w-full bg-gradient-to-r from-brand-gold via-brand-gold/60 to-brand-gold animate-gradient-x z-50 relative" data-id="element-1" />
      <Header data-id="element-2" />
      <main className="flex-1 flex flex-col" data-id="element-3">
        <HeroSection data-id="element-4" />

        <VideoSection data-id="element-5" />
        <StatsSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <ProcessSection data-id="element-8" />
        <WhoIsThisFor data-id="element-9" />
        <FoundersSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}